import { Plan } from '../../types/client';

// Action Types
export const SET_PLAN = 'SET_PLAN';

export const SET_ERROR = 'SET_ERROR';

interface PlanAction {
    type: typeof SET_PLAN;
    payload: Plan;
}

interface setErrorAction {
    type: typeof SET_ERROR;
    payload: string;
}

export type PlanActionTypes = PlanAction | setErrorAction;
